<div
  id="visionboard-lane-container"
  class="visionboard-lane-container"
  [ngClass]="{ showBorder: showBorder, disabled: disabled }"
>
  <div
    class="lane-title"
    *ngIf="showTitle"
  >
    {{ lane.title | uppercase }}
  </div>
  <div
    cdkDropList
    class="lane-items"
    [ngClass]="breakGrid"
    cdkDropListSortingDisabled="true"
    cdkDropListOrientation="horizontal"
  >
    <app-visionboard-workspace-template-lane-item
      *ngFor="let index of indices"
      cdkDrag
      [index]="index"
      [lane]="lane"
      [disableChecks]="disableChecks"
      class="lane-item"
      id="{{ index }}"
      (mouseenter)="onMouseEnter(index)"
      (mouseleave)="onMouseLeave()"
      (touchmove)="onTouchMove($event)"
      (click)="onMouseLeave()"
      (itemChange)="onItemChange($event)"
      (cdkDragStarted)="onDragStart($event, index)"
      (cdkDragReleased)="onDragReleased($event, index)"
      [cdkDragDisabled]="draggingDisabled(index)"
      cdkDragBoundary=".visionboard-lane-container"
    >
    </app-visionboard-workspace-template-lane-item>
  </div>
</div>

<mat-icon
  class="info-icon"
  svgIcon="instagram"
  [matTooltip]="infoText"
  matTooltipPosition="above"
  matTooltipShowDelay="1000"
  *ngIf="disabled"
></mat-icon>
